import { render, staticRenderFns } from "./CustomersChart.vue?vue&type=template&id=feac61fa&"
import script from "./CustomersChart.vue?vue&type=script&lang=js&"
export * from "./CustomersChart.vue?vue&type=script&lang=js&"
import style0 from "./CustomersChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports